import {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import {Box, CircularProgress, Paper} from '@mui/material'
import Stack from '@mui/material/Stack'
import {classesIP} from '../selectedPersonaStyles'
import PersonaOutreach from '../../../../api/queries/persona/PersonaOutreachQuery'
import {usePersona} from '../../../../store/hooks/persona'
import {ReactComponent as CellIcon} from '../../../../icons/Personas/Cell.svg'
import {ReactComponent as WebIcon} from '../../../../icons/Personas/Web.svg'
import {ReactComponent as MailIcon} from '../../../../icons/Personas/Mail.svg'
import {ReactComponent as EmailIcon} from '../../../../icons/Personas/Email.svg'
import {ReactComponent as TextIcon} from '../../../../icons/Personas/Text Messages.svg'
import {ReactComponent as PhoneIcon} from '../../../../icons/Personas/Phone.svg'
import {ReactComponent as FacebookIcon} from '../../../../icons/Personas/social-icons/Facebook.svg'
import {ReactComponent as InstagramIcon} from '../../../../icons/Personas/social-icons/Instagram.svg'
import {ReactComponent as TwitterIcon} from '../../../../icons/Personas/social-icons/X.svg'

const Outreach = ({filteredPersonaDesc, handlePersonaCustomLabel}) => {
  const [outreachData, setOutreachData] = useState('--')

  const {personaOutreach, loadingPersonaOutreach, refetchPersonaOutreach, errorLoadingPersonaOutreach} =
    PersonaOutreach()

  const {personas} = usePersona()
  const socialMedia = filteredPersonaDesc[0]?.socialMedia

  useEffect(() => {
    if (!loadingPersonaOutreach) {
      const data = personaOutreach?.personaOverview

      setOutreachData(data?.outreach ? data.outreach : 'Phone')
    }
  }, [personaOutreach, loadingPersonaOutreach, errorLoadingPersonaOutreach])

  useEffect(() => {
    refetchPersonaOutreach()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personas])

  const getIcon = (text) => {
    switch (String(text).toLowerCase()) {
      case 'email':
        return <EmailIcon />
      case 'cell':
        return <CellIcon />
      case 'web':
        return <WebIcon />
      case 'mail':
        return <MailIcon />
      case 'text':
        return <TextIcon />
      case 'phone':
        return <PhoneIcon />
      case 'facebook':
        return <FacebookIcon />
      case 'instagram':
        return <InstagramIcon />
      case 'twitter':
        return <TwitterIcon />

      default:
        break
    }
  }

  return (
    <>
      {loadingPersonaOutreach && <CircularProgress className={classesIP.CircularProgress} size={15} title='loading' />}

      <Typography className={[classesIP.personaSubTitle]} tabIndex={0} aria-label='Outreach Section'>
        {handlePersonaCustomLabel('outreach', 'OUTREACH')}
      </Typography>

      <Box className={classesIP.Box}>
        <Paper className={classesIP.Paper} elevation={1}>
          <Stack className={classesIP.Stack}>
            <Stack
              className={classesIP.overviewKeyChar1Stack}
              tabIndex={0}
              aria-label={`${outreachData}, Preferred outreach`}
            >
              <Stack direction='row' className={classesIP.overviewKeyChar1StackChild} spacing={1}>
                {getIcon(outreachData)}
              </Stack>
              <Typography className={classesIP.outreachLabel} variant='body2'>
                {outreachData}{' '}
              </Typography>
              <Typography className={[classesIP.engagementText, classesIP.outreachWide]} variant='body2' align='center'>
                {handlePersonaCustomLabel('outreach', 'Preferred outreach')}{' '}
              </Typography>
            </Stack>

            <Stack
              className={classesIP.overviewKeyChar1Stack}
              tabIndex={0}
              aria-label={
                socialMedia?.length > 1
                  ? `${socialMedia.join(', ')}, Most Popular social networks`
                  : `${socialMedia?.[0]}, Most Popular social network`
              }
            >
              {socialMedia?.length > 1 ? (
                <>
                  <Stack direction='row' className={classesIP.overviewKeyChar1StackChild} spacing={1}>
                    {socialMedia.map((data) => {
                      return getIcon(data)
                    })}
                  </Stack>
                  <Typography className={classesIP.outreachLabel} variant='body2'>
                    {socialMedia.join(',')}
                  </Typography>
                  <Typography
                    className={[classesIP.engagementText, classesIP.outreachWide]}
                    variant='body2'
                    align='center'
                  >
                    {handlePersonaCustomLabel('outreach', 'Most Popular social networks')}
                  </Typography>
                </>
              ) : (
                <>
                  <Stack direction='row' className={classesIP.overviewKeyChar1StackChild} spacing={1}>
                    {getIcon(socialMedia[0])}
                  </Stack>
                  <Typography className={classesIP.outreachLabel} variant='body2'>
                    {socialMedia[0]}
                  </Typography>
                  <Typography
                    className={[classesIP.engagementText, classesIP.outreachWide]}
                    variant='body2'
                    align='center'
                  >
                    {handlePersonaCustomLabel('outreach', 'Most Popular social network')}
                  </Typography>
                </>
              )}
            </Stack>
          </Stack>
        </Paper>
      </Box>
    </>
  )
}

Outreach.propTypes = {
  filteredPersonaDesc: PropTypes.shape({
    uninsuranceRisk: PropTypes.number,
    unemploymentRisk: PropTypes.number
    // Add other expected properties here
  }).isRequired,
  handlePersonaCustomLabel: PropTypes.func.isRequired
}

export default Outreach
